import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import '../../assets/css/styles.css'
import Config from '../../commons/config/Config.js';
import ConfigBusiness from '../../commons/config/ConfigBusiness.js'
import FormValidation from '../../commons/validation/FormValidation.js'
import Validator from '../../commons/validation/Validator.js'
import Loading from '../ui/Loading.js'
import swal from 'sweetalert'
import {FormattedMessage, injectIntl} from 'react-intl';
import backendStrings from '../../lang/backendStrings.js';
import Notificacion from '../app/Notificacion.js';

// --- DEVOPS FIX: DICCIONARIO DE EMERGENCIA ---
const FALLBACK_MESSAGES = {
    'login.errors.invalido': { id: 'login.errors.invalido', defaultMessage: 'Usuario o contraseña incorrectos.' },
    'login.errors.activar_cuenta': { id: 'login.errors.activar_cuenta', defaultMessage: 'Su usuario se encuentra inactivo. Contacte al administrador.' },
    'login.errors.No_se_encontro_numero_de_telefono_asociado_a_su_usuario': { id: 'login.errors.no_phone', defaultMessage: 'No se encontró un celular asociado para 2FA.' },
    'authService.errors.contrasenia_debe_tener_una_longitud_entre': { id: 'auth.pass.len', defaultMessage: 'La contraseña debe tener entre 8 y 16 caracteres.' },
    'errors.internal_server_error': { id: 'error.500', defaultMessage: 'Error interno del servidor.' }
};

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            formData: {
                usuario: null,
                clave: null
            },
            errors: [],
            loading: false,
            redirectTo: null,
            loginEnabled : ConfigBusiness.get("frontend.loginInstancia.habilitado"),
            mantenimientoEnabled: ConfigBusiness.get("frontend.mantenimiento.habilitado"),
            mantenimientoMensaje: (ConfigBusiness.get("frontend.mantenimiento.mensaje") || props.intl.formatMessage({id: 'login.mantenimiento.mensaje_default', defaultMessage: "Estamos realizando mejoras en el sistema.\nVolveremos a estar operativos a la brevedad."})).split('\n'),
            mantenimientoFechaFin: ConfigBusiness.get("frontend.mantenimiento.fechaFin"),
            mantenimientoCountdown: null,
            loginServices: {},
            azureLoginRedirect: Config.get('apiUrlBase') + '/public/auth/azure/redirect',
            googleLoginRedirect: Config.get('apiUrlBase') + '/public/auth/google/redirect',
            loadingLogoLogin: true,
            logoLoginUrl: null,
            languages: [],
            languagesExtra: {
                "es": props.intl.formatMessage({id: 'login.languages.español', defaultMessage: 'Español'}),
                "en": props.intl.formatMessage({id: 'login.languages.ingles', defaultMessage: 'Inglés'})
            },
            showVersionFull: false,
            configError: false,
            retryCountdown: 60
        }

        this.handleFormChange = this.handleFormChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleForgotPassword = this.handleForgotPassword.bind(this);
        this.loginRandom = null;
        this.changeLocale = this.changeLocale.bind(this);
        this.maintenanceInterval = null;
        this.statusCheckInterval = null;
        this.retryInterval = null;
    }

    getLogoSrc(configKey, defaultName) {
        const val = ConfigBusiness.get(configKey);
        if (val === "false") return null;
        if (!val || val === "true") return process.env.PUBLIC_URL + "/images/company/" + defaultName;
        return process.env.PUBLIC_URL + "/images/company/" + val;
    }

    updateCountdown = () => {
        if (!this.state.mantenimientoFechaFin) return;
        const fechaFin = new Date(this.state.mantenimientoFechaFin).getTime();
        const ahora = new Date().getTime();
        const distancia = fechaFin - ahora;

        if (distancia < 0) {
            this.setState({ mantenimientoCountdown: this.props.intl.formatMessage({id: 'login.mantenimiento.finalizando', defaultMessage: "Finalizando tareas..."}) });
            return;
        }

        const dias = Math.floor(distancia / (1000 * 60 * 60 * 24));
        const horas = Math.floor((distancia % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutos = Math.floor((distancia % (1000 * 60 * 60)) / (1000 * 60));
        const segundos = Math.floor((distancia % (1000 * 60)) / 1000);

        let text = "";
        if(dias > 0) text += `${dias}d `;
        text += `${horas}h ${minutos}m ${segundos}s`;
        this.setState({ mantenimientoCountdown: text });
    }

    checkMaintenanceStatus = () => {
        const timestamp = new Date().getTime();
        const checkUrl = Config.get('apiUrlBase') + '/public/auth/services?t=' + timestamp;

        fetch(checkUrl, { method: 'GET' })
            .then(res => {
                if(res.status === 200) {
                   res.json().then(data => {
                       if(this.state.mantenimientoFechaFin && new Date() > new Date(this.state.mantenimientoFechaFin)){
                           console.log("Mantenimiento: Tiempo cumplido. Recargando...");
                           window.location.reload();
                       }
                   });
                }
            }).catch(err => {});
    }

    startRetryCountdown = () => {
        if(this.retryInterval) clearInterval(this.retryInterval);
        this.setState({ retryCountdown: 60 });
        this.retryInterval = setInterval(() => {
            this.setState((prevState) => {
                if (prevState.retryCountdown <= 1) {
                    clearInterval(this.retryInterval);
                    window.location.reload();
                    return { retryCountdown: 0 };
                }
                return { retryCountdown: prevState.retryCountdown - 1 };
            });
        }, 1000);
    }

    componentWillMount () {
        this.formValidation = new FormValidation({
            component: this,
            validators: {
                'formData.usuario': (value) => Validator.notEmpty(value),
                'formData.clave': (value) => Validator.notEmpty(value)
            }
        });

        const customAppLogo = ConfigBusiness.get("frontend.logos.app");
        if (customAppLogo && customAppLogo !== "true" && customAppLogo !== "false") {
             this.setState({ logoLoginUrl: process.env.PUBLIC_URL + "/images/company/" + customAppLogo, loadingLogoLogin: false });
        } else {
            fetch(Config.get('apiUrlBase') + '/public/contextos_imagenes/logoLogin', {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
            }).then(response => {
                let contentType = response.headers.get('Content-Type');
                if (contentType && contentType.startsWith('image/')) {
                    return response.blob();
                } else {
                    throw new Error('La respuesta no es una imagen');
                }
            }).then(blob => {
                let fileUrl = URL.createObjectURL(blob);
                this.setState({ logoLoginUrl: fileUrl });
            }).catch((error) => {
            }).finally(() => {
                this.setState({ loadingLogoLogin: false });
            });
        }
    }

    componentDidMount () {
        document.body.className = 'vertical-layout vertical-menu 1-column menu-expanded blank-page blank-page';
        document.body.setAttribute('data-col', '1-column');

        const hostname = window.location.hostname;
        const isOldProd = (hostname === 'telecom.vec.com.ar' || hostname === 'telecom.vecfleet.io');
        const isOldTest = (hostname === 'testing-teco.vec.com.ar');

        if (this.state.mantenimientoEnabled === "true") {
            if (this.state.mantenimientoFechaFin) {
                this.updateCountdown();
                this.maintenanceInterval = setInterval(this.updateCountdown, 1000);
            }
            this.statusCheckInterval = setInterval(this.checkMaintenanceStatus, 30000);
        }

        if (isOldProd || isOldTest) {
            const target = isOldProd ? 'https://personal.vecfleet.io' : 'https://personal-test.vecfleet.io';
            this.setState({ isLegacyDomain: true, targetUrl: target });
            this.redirectInterval = setInterval(() => {
                this.setState((prevState) => {
                    if (prevState.countdown <= 1) {
                        clearInterval(this.redirectInterval);
                        window.location.replace(target);
                        return { countdown: 0 };
                    }
                    return { countdown: prevState.countdown - 1 };
                });
            }, 1000);
        }

        fetch(Config.get('apiUrlBase') + '/public/auth/services', {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
        }).then(response => {
            if(response.status === 200) {
                response.json().then(data => {
                    this.setState({
                        loginServices: data
                    })
                });
            } else {
                this.setState({ configError: true });
                this.startRetryCountdown();
            }
        }).catch((error) => {
            this.setState({ configError: true });
            this.startRetryCountdown();
        }).finally(() => {
            this.setState({ loading: false });
            if (this.state.loginServices.classic === 'true' && this.state.mantenimientoEnabled !== "true") {
                if(this.refs.usuario) this.refs.usuario.focus();
            }
        });

        let lang = ConfigBusiness.get("frontend.multilenguaje");
        try {
            const langJson = JSON.parse(lang);
            let langExtra = this.state.languagesExtra;

            if (langJson) {
                    this.state.languages = langJson.map(function(elem) {
                        switch(elem.lang) {
                            case "es": elem.title = langExtra[elem.lang]; break;
                            case "en": elem.title = langExtra[elem.lang]; break;
                        }
                        return elem;
                    });
            }
        } catch(e) {}
    }

    componentWillUnmount() {
        if (this.redirectInterval) clearInterval(this.redirectInterval);
        if (this.maintenanceInterval) clearInterval(this.maintenanceInterval);
        if (this.statusCheckInterval) clearInterval(this.statusCheckInterval);
        if (this.retryInterval) clearInterval(this.retryInterval);
    }

    handleFormChange(event) {
        const target = event.target;
        const name = target.name;
        const value = target.type === 'checkbox' ? target.checked : target.value;

        let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
        formDataCopy[name] = value;
        this.setState({ formData: formDataCopy });
    }

    handleSubmit(event) {
        this.setState({ loading: true });
        this.setState({ errors: [] });

        fetch(Config.get('apiUrlBase') + '/public/auth/login', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                ...this.state.formData
            }),
        }).then(response => {
            if(response.status === 200) {
                response.json()
                    .then(data => {
                        if(data && data.usuario && data.usuario.token) {
                            localStorage.setItem('persona', JSON.stringify(data));
                            localStorage.setItem('token', data.usuario.token);
                            localStorage.setItem('cerrarNotificacion', false);
                            if (data.usuario.enable_twofa && ConfigBusiness.get("2fa.habilitado") == "true") {
                                if(!data.celularCodArea || !data.celularNumero){
                                    swal({
                                        title: this.props.intl.formatMessage({ id: 'login.errors.Contacte_al_administrador', defaultMessage: 'Contacte al administrador' }),
                                        text: this.props.intl.formatMessage({...(backendStrings['login.errors.No_se_encontro_numero_de_telefono_asociado_a_su_usuario'] ? backendStrings['login.errors.No_se_encontro_numero_de_telefono_asociado_a_su_usuario'] : backendStrings['errors.default']) }),
                                        icon: "error",
                                        buttons: { confirm: { text: "Aceptar", className: "btn btn-primary", closeModal: true } }
                                    });
                                }else{
                                    this.setState({ redirectTo: '/auth/2fa' })
                                }
                            } else {
                                window.location.reload();
                            }
                        } else {
                            this.error();
                        }
                    });
            } else if(response.status === 401) {
                response.json().then(data => {
                    let msgs = data.detalle || ['login.errors.invalido'];
                    this.setState({ errors: msgs });
                }).catch(() => {
                    this.setState({ errors: ['login.errors.invalido'] });
                });
            } else if(response.status === 400 || response.status === 403) {
                response.json().then(data => {
                        const msgKey = (data.detalle && data.detalle[0]) ? data.detalle[0] : 'errors.default';
                        swal({
                            title: this.props.intl.formatMessage({ id: 'login.errors.Contacte_al_administrador', defaultMessage: 'Contacte al administrador' }),
                            text: this.props.intl.formatMessage({...(backendStrings[msgKey] ? backendStrings[msgKey] : {id: msgKey, defaultMessage: data.message || msgKey}) }),
                            icon: "error",
                            buttons: { confirm: { text: "Aceptar", className: "btn btn-primary", closeModal: true } }
                        });
                    });
            }else {
                this.error();
            }
        }).catch((error) => {
            this.error();
        }).finally(() => {
            this.setState({ loading: false });
        });

        event.preventDefault();
    }

    handleForgotPassword(e) {
        this.setState({ redirectTo: '/olvide-clave' });
        e.preventDefault();
    }

    changeLocale(locale) {
        localStorage.setItem('userLocale', locale);
        window.location.reload();
    }

    error() {
        swal({
            title: this.props.intl.formatMessage({ id: 'login.errors.swal.title', defaultMessage: 'Error interno del sistema.' }),
            text: this.props.intl.formatMessage({ id: 'login.errors.swal.text', defaultMessage: 'Contacte al administrador.' }),
            icon: "error",
            buttons: {
                confirm: {
                    text: this.props.intl.formatMessage({ id: 'login.errors.swal.buttons', defaultMessage: 'Aceptar' }),
                    value: true,
                    visible: true,
                    className: "btn btn-primary",
                    closeModal: true
                }
            }
        });
    }

    render() {
        this.formValidation.validate();
        let validationState = this.formValidation.state;
        if(!this.loginRandom) this.loginRandom = 1 + Math.floor((4 - 1) * Math.random());

        const logoCompanySrc = this.getLogoSrc("frontend.logos.company.visible", "logo-login-company.png");
        const logoPoweredBySrc = this.getLogoSrc("frontend.logos.poweredBy.visible", "logo-login-powered-by.png");
        const versionLabel = process.env.REACT_APP_VERSION || "0.0.0";
        const isVersionLong = versionLabel.length > 10;

        const deadlineDate = new Date('2026-01-08T00:00:00');
        const now = new Date();
        const dateText = now > deadlineDate
            ? "Esta plataforma dejará de estar operativa próximamente."
            : "Esta plataforma dejará de estar operativa el 08/01/2026.";

        return (
            <React.Fragment>
                {ConfigBusiness.get("generales.alertaSuspension")==='true' ?
                    <Notificacion
                        closeable={false}
                        title={this.props.intl.formatMessage({ id: 'layout.Alerta_de_suspension_por_falta_de_pago', defaultMessage: 'Alerta de suspensión por falta de pago' })}
                        message={this.props.intl.formatMessage({ id: 'layout.Tu_cuenta_tiene_un_pago_pendiente', defaultMessage: 'Tu cuenta tiene un pago pendiente. Por favor regularice la situación.' })}
                        top="0"
                    />
                : null}
                {this.state.redirectTo && <Redirect push to={this.state.redirectTo} />}
                {this.state.loading && <Loading hideSpinner />}
                <div className="app-content content">
                    <div className="content-wrapper">
                        <div className="content-header row"></div>
                        <div className="content-body">
                            <video className="video-login-bg" autoPlay muted loop type="video/mp4" poster={process.env.PUBLIC_URL + "/images/images-login/image"+ this.loginRandom +".png"}>
                                <source src={process.env.PUBLIC_URL + "/images/videos-login/video"+ this.loginRandom +".mp4"} type="video/mp4"/>
                                <img src={process.env.PUBLIC_URL + "/images/images-login/image"+ this.loginRandom +".png"} alt="Video no soportado"/>
                            </video>
                            <section className="flexbox-container">
                                <div className="col-12 d-flex align-items-center justify-content-center">
                                    <div className="col-md-4 col-10 box-shadow-2 p-0">
                                        <div className="card border-grey border-lighten-3 px-2 py-2 m-0" style={{position: 'relative'}}> {/* DEVOPS FIX: position relative para contener el boton absoluto */}
                                            
                                            <div id="loginLogo" className="card-header border-0 text-center" style={{padding: 0}}>
                                                <img src={this.state.logoLoginUrl || process.env.PUBLIC_URL + "/images/company/logo-login-app.png"} alt="" className="rounded-circle img-fluid center-block" style={{ maxHeight: '130px' }} />
                                            </div>
                                            <div className="card-content">
                                                <div className="card-body" style={{paddingTop: 0}}>

                                                    {this.state.configError ? (
                                                        <div className="text-center py-2 px-1">
                                                            <div className="mb-2"><i className="la la-exclamation-triangle" style={{ fontSize: '50px', color: '#dc3545' }}></i></div>
                                                            <h4 className="mb-2 text-danger font-weight-bold">Problemas de Conexión</h4>
                                                            <p className="text-muted">No se pudo establecer comunicación con el servidor.<br/>Estamos intentando reconectar.</p>
                                                            <div className="mt-3"><div className="progress mb-2" style={{height: '5px'}}><div className="progress-bar bg-danger" role="progressbar" style={{width: (this.state.retryCountdown / 60 * 100) + '%'}}></div></div><small className="text-muted">Reintentando en {this.state.retryCountdown}s...</small></div>
                                                            <button className="btn btn-outline-danger btn-block mt-3" onClick={() => window.location.reload()}><i className="la la-refresh"></i> Reintentar Ahora</button>
                                                        </div>
                                                    ) : this.state.mantenimientoEnabled === "true" ? (
                                                        <div className="text-center py-2 px-1">
                                                            <div className="mb-2"><i className="la la-cog spinner" style={{ fontSize: '50px', color: '#ff9800' }}></i></div>
                                                            <h3 className="mb-2" style={{ fontWeight: 'bold' }}><FormattedMessage id="login.mantenimiento.titulo" defaultMessage="Plataforma en Mantenimiento" /></h3>
                                                            <div className="alert alert-warning border-warning" role="alert">{this.state.mantenimientoMensaje.map((linea, idx) => (<p key={idx} className="mb-0" style={{fontSize: '14px'}}>{linea}</p>))}</div>
                                                            {this.state.mantenimientoCountdown && (<div className="mt-2"><p className="text-muted font-small-3 mb-0">Tiempo estimado restante:</p><span className="badge badge-secondary p-1" style={{fontSize: '16px', fontFamily: 'monospace'}}><i className="la la-clock-o"></i> {this.state.mantenimientoCountdown}</span></div>)}
                                                        </div>
                                                    ) : (
                                                    <React.Fragment>
                                                        {this.state.isLegacyDomain ? (
                                                            <div className="text-center py-2 px-1">
                                                                <h3 className="mb-2" style={{color: '#0033A0', fontWeight: 'bold'}}>¡Nos estamos mudando!</h3>
                                                                <div className="alert alert-info border-info" role="alert"><p className="mb-1">Estamos renovando nuestra imagen para brindarte una mejor experiencia.</p><hr className="my-1"/><p className="font-weight-bold mb-0">{dateText}</p></div>
                                                                <div className="mb-2"><small>Redirigiendo automáticamente en <strong>{this.state.countdown}</strong>s...</small></div>
                                                                <button className="btn btn-success btn-lg btn-block shadow-sm" onClick={() => window.location.href = this.state.targetUrl}>Ir al nuevo sitio <i className="la la-arrow-right"></i></button>
                                                            </div>
                                                        ) : (
                                                            <div className="login-normal-flow">
                                                                {this.state.loginEnabled == "false" ? (
                                                                    <div class="text-center py-2"><h3>La plataforma no se encuentra disponible.</h3><span>Por favor, contacte a su Ejecutivo de Cuentas.</span></div>
                                                                ) : (
                                                                    <React.Fragment>
                                                                    {this.state.loginServices.classic === 'true' &&
                                                                        <form className="form-horizontal" noValidate ref="form" onSubmit={this.handleSubmit}>
                                                                            <p id="loginSubtitle" className="card-subtitle line-on-side text-muted text-center font-small-3 mb-2"></p>
                                                                            <fieldset className="form-group position-relative has-icon-left">
                                                                                <input type="text" className="form-control form-control-lg input-lg" id="usuario" name="usuario" ref="usuario" placeholder={this.props.intl.formatMessage({ id: 'login.usuario.placeholder', defaultMessage: 'Usuario' })} tabIndex="1" required="" data-validation-required-message={this.props.intl.formatMessage({ id: 'login.usuario.data-validation-required-message', defaultMessage: 'Por favor ingrese su usuario.' })} aria-invalid="false" onChange={this.handleFormChange} />
                                                                                <div className="form-control-position"><i className="la la-user"></i></div>
                                                                                <div className="help-block text-danger font-small-3" hidden={validationState.formData.usuario.pristine || validationState.formData.usuario.valid}>{validationState.formData.usuario.message}</div>
                                                                            </fieldset>
                                                                            <fieldset className="form-group position-relative has-icon-left">
                                                                                <input type="password" className="form-control form-control-lg input-lg" id="clave" name="clave" placeholder={this.props.intl.formatMessage({ id: 'login.contraseña.placeholder', defaultMessage: 'Contraseña' })} tabIndex="2" required onChange={this.handleFormChange} />
                                                                                <div className="form-control-position"><i className="la la-key"></i></div>
                                                                                <div className="help-block text-danger font-small-3" hidden={validationState.formData.clave.pristine || validationState.formData.clave.valid}>{validationState.formData.clave.message}</div>
                                                                            </fieldset>
                                                                            <div className="form-group row">
                                                                                <div className="col-12 float-sm-left text-center text-sm-right">
                                                                                    <button type="button" className="buttonAsLink card-link primary" onClick={e => this.handleForgotPassword(e)}>
                                                                                        <i className="ft-unlock"></i>&nbsp;<FormattedMessage id="login.contraseña.olvido" defaultMessage="Olvidó su contraseña?"/>
                                                                                    </button>
                                                                                </div>
                                                                            </div>
                                                                            <div className="alert alert-danger" role="alert" hidden={this.state.errors.length===0}>
                                                                                {this.state.errors.map((e, i) => {
                                                                                    let msg = backendStrings[e];
                                                                                    if (!msg) msg = FALLBACK_MESSAGES[e];
                                                                                    if (!msg) msg = backendStrings['errors.default'] || { id: 'error.generic', defaultMessage: 'Ha ocurrido un error' };
                                                                                    return <li key={i}><FormattedMessage {...msg}/></li>
                                                                                })}
                                                                            </div>
                                                                            <button type="submit" className="btn btn-outline-primary btn-lg btn-block" disabled={!validationState.form.valid}>
                                                                                <i className={this.state.loading ? 'la la-spinner spinner' : 'la la-lock'}></i><FormattedMessage id="login.ingresar" defaultMessage="Ingresar"/>
                                                                            </button>
                                                                        </form>
                                                                    }
                                                                    {this.state.loginServices.google === 'true' && <div className="mt-2"><a href={this.state.googleLoginRedirect} className="my-2 text-center"><div className="card d-flex align-items-center" style={{display:'flex', flexDirection:'row', padding:'10px 20px', border:'1px solid #ddd', borderRadius:'8px', backgroundColor:'#f9f9f9', maxWidth:'300px', margin:'10px auto', cursor:'pointer'}}><img style={{width:'40px', height:'40px', marginRight:'5px'}} src={process.env.PUBLIC_URL + "/images/google.svg"} alt=""/><span style={{fontSize:'16px', color:'#333', flex:1}}><FormattedMessage id="login.google" defaultMessage="Sign in with Google" /></span></div></a></div>}
                                                                    {this.state.loginServices.azure === 'true' && <div className="mt-2"><a href={this.state.azureLoginRedirect} className="my-2 text-center"><div className="card d-flex align-items-center" style={{display:'flex', flexDirection:'row', padding:'10px 20px', border:'1px solid #ddd', borderRadius:'8px', backgroundColor:'#f9f9f9', maxWidth:'300px', margin:'10px auto', cursor:'pointer'}}><img style={{width:'40px', height:'40px', marginRight:'5px'}} src={process.env.PUBLIC_URL + "/images/microsoft.svg"} alt=""/><span style={{fontSize:'16px', color:'#333', flex:1}}><FormattedMessage id="login.microsoft" defaultMessage="Sign in with Microsoft" /></span></div></a></div>}
                                                                    </React.Fragment>
                                                                )}
                                                            </div>
                                                        )}
                                                    </React.Fragment>
                                                    )}

                                                    <div className="row mt-2">
                                                        <div className="col-6">{logoCompanySrc && <img src={logoCompanySrc} alt="" className="img-fluid center-block" />}</div>
                                                        <div className="col-6 text-right">{logoPoweredBySrc && <img src={logoPoweredBySrc} alt="" className="img-fluid center-block" />}</div>
                                                    </div>

                                                    <div className="text-center mt-2">
                                                        {this.state.languages.map(function(elem,index,arr) {return(<><span onClick={e => this.changeLocale(elem.lang)} className="cursor-pointer" title={elem.title}><img class="flag-multilang" src={process.env.PUBLIC_URL + "/images/flags/" + elem.code + ".svg"}/></span>{index < arr.length-1 && <>&nbsp;|&nbsp;</>}</>) }, this)}
                                                        <div className="version-info d-flex flex-column align-items-center mt-1">
                                                            {isVersionLong ? (<React.Fragment><button type="button" className="btn btn-sm btn-link text-muted p-0" style={{ fontSize: '10px' }} onClick={() => this.setState({ showVersionFull: !this.state.showVersionFull })}>Versión {this.state.showVersionFull ? '▲' : '▼'}</button>{this.state.showVersionFull && <div className="badge badge-light text-muted p-1 mt-1">{versionLabel}</div>}</React.Fragment>) : (<small className="text-muted" style={{ fontSize: '10px' }}>v{versionLabel}</small>)}
                                                        </div>
                                                    </div>

                                                    {/* DEVOPS FIX: BOTÓN DE LIMPIEZA DE CACHÉ (ESCOBITA) */}
                                                    <div style={{ position: 'absolute', bottom: '10px', right: '10px', opacity: 0.5, transition: 'opacity 0.2s', cursor: 'pointer' }} 
                                                         onMouseEnter={(e) => e.currentTarget.style.opacity = 1} 
                                                         onMouseLeave={(e) => e.currentTarget.style.opacity = 0.5}>
                                                        <a href="/salir" title={this.props.intl.formatMessage({id: 'login.clear_cache', defaultMessage: 'Limpiar Caché'})}>
                                                            <i className="la la-broom" style={{ fontSize: '18px', color: '#ccc' }}></i>
                                                        </a>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default injectIntl(Login);
